import { Icon, IconProps } from "@chakra-ui/react";

export default function FlowerGreenBackground(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 44 44"
      fill="none"
      {...props}
    >
      <circle cx="22" cy="22" r="22" fill="#DBF3DA" />
      <path
        d="M12 12C14.3859 12 16.5721 12.8565 18.2685 14.2777C20.4069 16.0696 21.7668 18.7592 21.7668 21.7676C21.7668 18.7592 23.1267 16.0696 25.2651 14.2777C26.9614 12.8565 29.1476 12 31.5336 12V22.2634H31.5143C31.5268 22.453 31.5336 22.6435 31.5336 22.8356C31.5336 27.8968 27.1611 32 21.7668 32C16.3725 32 12 27.8968 12 22.8356C12 22.6435 12.0067 22.453 12.0193 22.2634H12V12Z"
        fill="#8491D9"
      />
    </Icon>
  );
}
